import { Block } from '@openlaw-au/types';
import { FunctionComponent } from 'react';
import BlockRenderer from './blockRenderer';

interface Props {
  block: Block;
}

const FootnoteRenderer: FunctionComponent<Props> = ({ block }) => {
  return (
    <div className="flex flex-col">
      {block.meta[0].value && parseInt(block.meta[0].value) < 10 ? (
        <div className="flex pr-2">
          <p>{block.meta[0].value}</p>
        </div>
      ) : (
        <div>
          <div className="flex ">
            <p>{block.meta[0].value}</p>
          </div>
        </div>
      )}
      <div className="flex flex-col pl-10">
        {block.blocks.map((b: Block, k) => {
          return <BlockRenderer block={b} key={k} />;
        })}
      </div>
    </div>
  );
};

export default FootnoteRenderer;
